import { useHomepage } from "@/Apollo/hooks/homepage/useHomepage";
import {
  HomepageQuery_homepage_Homepage_blocks,
  HomepageQuery_homepage_Homepage_blocks_CategoriesBlock,
} from "@/Apollo/schema";
import { useLanguage } from "@/common/hooks/pages.hooks";

const isCategoriesBlock = (
  block: HomepageQuery_homepage_Homepage_blocks
): block is HomepageQuery_homepage_Homepage_blocks_CategoriesBlock =>
  block.__typename === "CategoriesBlock";

export const useHomepageMobileCategories = () => {
  const { language } = useLanguage();

  const { data, loading, error } = useHomepage({
    variables: {
      lang: language,
    },
  });

  const categories =
    data?.homepage?.blocks.filter(isCategoriesBlock)?.[0]?.categories;

  return { categories, loading, error };
};
